import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Location } from '@angular/common';
import { Component, HostListener, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SnLayoutService } from '@lib/ui/layout';

import { SnListItem } from '../../models';

@Component({
  selector: 'sn-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  host: {
    class: 'sn-list__item',
  },
})
export class SnListItemComponent implements OnDestroy {
  public isCtrlHeld: boolean = false;

  @Input()
  public item: SnListItem;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _layout: SnLayoutService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _location: Location,
  ) {}

  @HostListener('window:keydown', ['$event'])
  public handleKeydown(event: KeyboardEvent): void {
    if (event.ctrlKey || event.key === 'Meta') {
      this.isCtrlHeld = true;
    }
  }

  @HostListener('window:keyup', ['$event'])
  public handleKeyup(event: KeyboardEvent): void {
    if (event.ctrlKey || event.key === 'Meta') {
      this.isCtrlHeld = false;
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  get canSeeSecondaryNavbar(): boolean {
    return this._layout.navbar.canSeeSecondaryNavbar;
  }

  public setSecondaryNavbarHidden(bool: boolean): void {
    this._layout.navbar.setSecondaryNavbarHidden(bool);
  }

  get hasSecondaryNavbar(): boolean {
    return this._layout.navbar.hasSecondaryNavbar;
  }

  public getResolvedRouteLink(): string | string[] {
    const currentPath = this._location.path();
    const segments = currentPath.split('/').filter(Boolean);
    const routeLink = this.item?.route?.link?.toString() || '';

    // If there are query params but no route link, return empty array to stay on current route
    if (this.item?.route?.queryParams && !routeLink) {
      return [];
    }

    if (routeLink) {
      return [routeLink];
    }

    return ['/', ...segments];
  }

  public goToLink(link: SnListItem): void {
    if (link) {
      if (link.route?.link && !link.route?.queryParams) {
        this._activatedRoute.parent.url.pipe(takeUntil(this._destroy$)).subscribe((res) => {
          res.length
            ? window.open(`${res[0].path}/${link.route?.link.toString()}`, '_blank')
            : window.open(link.route?.link.toString(), '_blank');
        });
      }

      if (!link.route?.link && link.route?.queryParams) {
        let url = this._location.path(false);
        const params = new URLSearchParams(link.route.queryParams);
        if (url.includes('?')) {
          url = url.split('?')[0];
        }
        window.open(`${url}?${params}`, '_blank');
      }

      if (link.route?.link && link.route?.queryParams) {
        const params = new URLSearchParams(link.route.queryParams);
        this._activatedRoute.parent.url.pipe(takeUntil(this._destroy$)).subscribe((res) => {
          res.length
            ? window.open(`${res[0].path}/${link.route?.link.toString()}?${params}`, '_blank')
            : window.open(link.route?.link.toString(), '_blank');
        });
      }
    }
  }
}
